import { Button } from '@mui/material';
import VisuallyHiddenInput from './VisuallyHiddenInput';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { useState } from 'react';


const PORTRAITSERVICEURL = "https://eyeprocessorsite.affarintech.com/portrait";

const Portrait = () =>{

  const [busy, setBusy] = useState(false);
    
  const clear = () =>{
    setBusy(true);
    fetch(PORTRAITSERVICEURL+"clear", {
      method: "GET", 
    }).then((response) => {
      setBusy(false);
      console.log(response);
    })
    .catch((e) => {
      setBusy(false);
      console.log("error "+e);
    });
    
  }

  const upLoad = (e) => {
    if (e?.target?.files && e.target.files.length > 0) {
      console.log(e.target.files[0]);
      let formData = new FormData();
      e.target.files.map( (obj, index) =>{
        formData.append("file", obj);
        formData.append("name", obj.name );
      });
      setBusy(true);
      fetch(PORTRAITSERVICEURL+"add", {
        method: "POST", 
        body: formData
      }).then((response) => response.json())
        .then((data) => {
        setBusy(false);
        console.log("success on upload");  
      }).catch( e => {
        setBusy(false);
        console.log("error on upload");
      });
    }
  };

  return (<div class="horizontal">
    <Button component="label" tabIndex={-1} role={undefined} onClick={clear} 
      color={'secondary'} variant="contained" startIcon={<FileUploadIcon/>}>Clear
    </Button>
    <Button component="label" tabIndex={-1} role={undefined} variant="contained" 
      startIcon={<FileUploadIcon/>}>Push
      <VisuallyHiddenInput type="file" onChange={upLoad} multiple={true} />
    </Button>
    </div>);
}

export default Portrait;